import React from "react";
import MatomoContext from "./matomo.context";
var MatomoProvider = function (props) {
    var children = props.children, value = props.value;
    return (React.createElement(MatomoContext.Provider, { value: value }, children));
};
export default MatomoProvider;
